import { Spacer } from "@hackthenorth/north";
import { Link, Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { FullPageNotionEmbed, Header } from "src/shared/components";
import { Route } from "src/shared/constants/route";
import { useUserContext } from "src/shared/contexts";
import { useSponsorContext } from "src/shared/contexts/SponsorContext";

import PostEventReportCard from "../../post-event-report/PostEventReportCard";

const NOTION_PAGE_URL =
  "https://hackthenorth.notion.site/ebd/33ab70e03de780bea041c038967e6637";

const SponsorDashboard: React.FC = () => {
  const { info } = useUserContext();
  const userName = info?.name.split(" ")[0] ?? "there";
  const { company } = useSponsorContext();
  const companyName = company?.name ?? "your company";
  const driName = company?.dri_user?.name;
  const driEmail = company?.dri_user?.email;

  return (
    <>
      <Header
        title="Sponsor Dashboard"
        subtitle="Pleasure doing business with you!"
      />
      <SponsorIntro>
        <HeaderText>Hi, {userName}!</HeaderText>

        <Text type="h3">
          We&apos;re grateful for {companyName}&apos;s support!
        </Text>
        {driName && (
          <>
            <Spacer height={12} />
            <Text>
              <b>Your HTN contact:</b> {driName}
              {driEmail && (
                <>
                  ,{" "}
                  <Link href={`mailto:${driEmail}`} openInNewTab={false}>
                    {driEmail}
                  </Link>
                </>
              )}
            </Text>
          </>
        )}
        <Spacer height={12} />
        <Text>
          Welcome to Sponsor Dashboard! This is your one-stop shop for
          everything you need to make the most of your sponsorship. From here,
          you can coordinate your perks with your sponsor rep, browse and
          recruit our talented hackers, and stay on top of everything happening
          at the event, all in one place.
        </Text>
        <Spacer height={8} />
        <Text>
          Head to{" "}
          <Link href={Route.SPONSOR_PERKS} openInNewTab={false}>
            Perks
          </Link>{" "}
          to view and submit your available perks, and visit{" "}
          <Link href={Route.SPONSOR_RECRUITMENT} openInNewTab={false}>
            Recruitment
          </Link>{" "}
          to connect with our incredibly talented hackers!
        </Text>
        <PostEventReportCard />
      </SponsorIntro>
      <FullPageNotionEmbed
        url={NOTION_PAGE_URL}
        title="Sponsor information Notion page"
        fallbackText="about your perks and day-of logistics!"
      />
    </>
  );
};

const SponsorIntro = styled.section`
  width: 100%;
  padding: 42px 56px 32px;

  ${({ theme }) => theme.mediaQueries.tablet`
    padding: 40px;
  `}

  ${({ theme }) => theme.mediaQueries.largeMobile`
    padding: 24px;
  `}

  ${({ theme }) => theme.mediaQueries.smallMobile`
    padding: 20px;
  `}
`;

const HeaderText = styled.h1`
  color: #000;
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.heading};
  font-size: 34px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  margin-bottom: 24px;
`;

export default SponsorDashboard;
